import { User } from "lucide-react";
import { useGetIdentity, useTranslate } from "ra-core";
import { Link } from "react-router";

import { PaginaPerfil } from "../ajustes/PaginaPerfil";
import { useResponsables } from "../datos/useResponsables";
import { iniciales } from "../negocios/formato";
import { AvatarUsuario } from "../usuarios/FotoUsuario";

/**
 * Foto o iniciales arriba a la derecha de Inicio en el móvil, que llevan a Perfil (19/10/2026). En
 * el móvil no hay barra lateral y, con la app instalada, tampoco barra de direcciones: sin esto no
 * se llega a Perfil (avisos en este móvil, foto, cerrar sesión).
 */
export const EnlacePerfilMovil = () => {
  const translate = useTranslate();
  const { identity } = useGetIdentity();
  const { foto } = useResponsables();
  const nombre = identity?.fullName ?? "";
  return (
    <Link
      to={PaginaPerfil.path}
      aria-label={translate("nevora.nav.perfil")}
      className="flex size-9 items-center justify-center rounded-full"
      data-testid="enlace-perfil-movil"
      data-guia="perfil-movil"
    >
      {foto(identity?.id) ? (
        <AvatarUsuario
          nombre={nombre}
          foto={foto(identity?.id)}
          className="size-7 text-xs"
        />
      ) : (
        <span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-[#0A0A0A] text-[#FAFAF7] text-xs font-semibold">
          {iniciales(nombre) || <User className="size-4" />}
        </span>
      )}
    </Link>
  );
};
